/**
 * Smooth scroll to element with fixed navbar offset
 */
export function scrollToElement(elementId: string, navbarHeight: number = 80) {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

/**
 * Scroll to sell watch form - handles different page scenarios
 * @param openDialogCallback - Optional callback to open dialog if scrolled past hero
 */
export function scrollToSellWatchForm(openDialogCallback?: () => void) {
  const isHomePage = window.location.pathname === '/';
  
  if (isHomePage) {
    // Check if hero is visible or if we have a dialog callback
    const heroElement = document.querySelector('section.wrapper:first-child');
    const hasScrolledPastHero = heroElement ? heroElement.getBoundingClientRect().bottom < 0 : false;
    
    if (hasScrolledPastHero && openDialogCallback) {
      // User has scrolled past hero - open dialog instead
      openDialogCallback();
    } else {
      // Hero is visible - scroll to the multistep form
      scrollToElement('sell-watch-form', 80);
    }
  } else {
    // On other pages - navigate to home then scroll
    window.location.href = '/#sell-watch-form';
  }
}

/**
 * Navigate to contact page - handles different page scenarios
 */
export function navigateToContact() {
  const isContactPage = window.location.pathname === '/contact';
  
  if (!isContactPage) {
    // Not on contact page - navigate to contact page
    window.location.href = '/contact';
  }
  // If already on contact page, do nothing
}
